import logo from './logo.svg';
import './App.css';
import Android from './googlePlay.png'
import Apple from './appStore1.png'
import One from './1.png'
import Two from './2.png'
import Three from './3.png'
import Four from './4.png'
import Five from './5.png'
import Six from './6.png'
import Seven from './7.png'
import Eight from './8.png'

function App() {
  return (
    <div className="App">
      <div className='heading'>
        Messoka
      </div>
      <div className='desc'>
        Experience Wholesome Meals
      </div>
      <div className='launching'>
        Launching Soon On
      </div>
      <div className='logo'>
        <img src={Android} className="App-logo" alt="logo" />
        <img src={Apple} className="App-logo" alt="logo" />
      </div>

      <div className='design'>
        App UI
      </div>

      <div className='photos'>
        <img src={One} className="designLogo" alt="logo" />
        <img src={Two} className="designLogo" alt="logo" />
        <img src={Three} className="designLogo" alt="logo" />
        <img src={Four} className="designLogo" alt="logo" />
        <img src={Five} className="designLogo" alt="logo" />
        <img src={Six} className="designLogo" alt="logo" />
        <img src={Seven} className="designLogo" alt="logo" />
        <img src={Eight} className="designLogo" alt="logo" />
      </div>

      <div className='register'>Register Your Mess Now And Get Benefits Like :</div>
      <div className='benefits'>
        <div className='feature'>1.  &nbsp;Free Registration</div>
        <div className='feature'>2.  &nbsp;Online visibility</div>
        <div className='feature'>3.  &nbsp;Subscription management</div>
        <div className='feature'>4.  &nbsp;Customer engagement</div>
        <div className='feature'>5.  &nbsp;Marketing opportunities</div>  
        <div className='feature'>6.  &nbsp;Scalability</div>
      </div>
    </div>
  );
}

export default App;
